import editableDemoTpl from '../templates/creative_preview/editable_demo.directive.html';

function EditableDemoController(
  IsImageFactory,
  CreativeService,
  $scope
) {
  const vm = this;

  vm.$onInit = () => {
    vm.staticDemo = $scope.staticDemo;
    vm.isImage = IsImageFactory;
    vm.creativeService = CreativeService;
    vm.checkDescriptionLength = checkDescriptionLength;
  };

  function checkDescriptionLength() {
    if (CreativeService.creative.description.length > 140) {
      vm.descriptionTooLong = true;
      CreativeService.creative.description = CreativeService.creative.description.substring(
        0,
        140
      );
    } else {
      vm.descriptionTooLong = false;
    }
  }

  return vm;
}

EditableDemoController.$inject = [
  'IsImageFactory',
  'CreativeService',
  '$scope'
];

export default function strEditableDemo() {
  return {
    template: editableDemoTpl,
    controller: EditableDemoController,
    controllerAs: 'editVm',
    scope: {
      staticDemo: '='
    }
  };
}
